import { Box, CircularProgress } from '@mui/material';
import { useTheme } from '@silverstein-properties/inspirelabs-ui';
import { useState } from 'react';

export const LazyImage = ({
  src,
  alt,
  width,
  height,
}: {
  src: string;
  alt: string;
  width?: string;
  height?: string;
}) => {
  const theme = useTheme();
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <Box
      sx={{
        width: width || '100%',
        height: height || '260px',
        objectFit: 'cover',
        borderRadius: theme.spacing(1.25),
        overflow: 'hidden',
      }}
    >
      {!isLoaded && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box
        component="img"
        loading="lazy"
        onLoad={() => setIsLoaded(true)}
        src={src}
        alt={alt}
        sx={{
          width: width || '100%',
          height: height || '260px',
          objectFit: 'cover',
        }}
      />
    </Box>
  );
};
